import type { Note, NoteView } from './types'

export function canReadNote(note: Pick<Note, 'ownerId' | 'visibility' | 'collaboratorIds'>, userId: string) {
  return note.ownerId === userId || note.visibility === 'family' || note.collaboratorIds.includes(userId)
}

export function isPurgeable(note: Pick<Note, 'trashedAt'>, now = Date.now()) {
  return Boolean(note.trashedAt && new Date(note.trashedAt).getTime() <= now - 30 * 24 * 60 * 60 * 1000)
}

export function isInView(note: Note, view: NoteView, currentUserId: string) {
  if (view === 'trash') return Boolean(note.trashedAt)
  if (note.trashedAt) return false
  if (view === 'archive') return Boolean(note.archivedAt)
  if (note.archivedAt) return false
  if (view === 'shared') return note.visibility === 'family' || note.collaboratorIds.length > 0 || note.ownerId !== currentUserId
  if (view.startsWith('label:')) return note.labelIds.includes(view.slice(6))
  return true
}

export function groupNotesByPin<T extends Pick<Note, 'isPinned'>>(notes: T[]): T[][] {
  const pinned = notes.filter((note) => note.isPinned)
  const unpinned = notes.filter((note) => !note.isPinned)
  return pinned.length && unpinned.length ? [pinned, unpinned] : [notes]
}
